import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const StatusSolutions = (function() {

  function GetAllGroups(statusSolutionsId) {
    if (logComponent('StatusSolutions')) { console.debug('StatusSolutions GetAllGroups'); }
      const params = { statusSolutionsId };
      return axios.get('api/StatusSolutions/GetAllGroups', getConfig( params));
  }


  return {
    GetAllGroups
  }
})();

export default StatusSolutions;